<template>
<div>

    <wewHeader></wewHeader>

    <wewSteps v-bind:stepActive="4"></wewSteps>

    <section class="step-4 pad-t-90 pad-b-80" style="background: #EFEFEF;margin-top:-100px;">

        <div class="container">
        <h1 class="text-center">TELL US ABOUT <span style="color:#008EC8;text-transform:uppercase;">YOURSELF</span></h1>
        
        <form class="car-details-form pad-t-40" @submit.prevent="validateBeforeSubmit('success')">
            
            <div class="pad-lr-md-120 pad-lr-lg-220 pad-lr-xl-260">

                <div class="question">
                    <div class="q-title">First Name</div>
                    <div class="q-field">
                        <textbox v-bind:textbox="firstName"></textbox>
                    </div>     
                </div>

                <div class="question">
                    <div class="q-title">Surname</div>
                    <div class="q-field">
                        <textbox v-bind:textbox="surname"></textbox>
                    </div>     
                </div>

                <div class="question">
                    <div class="q-title">Email</div>
                    <div class="q-field">
                        <textbox v-bind:textbox="email"></textbox>
                    </div>     
                </div>

                <div class="question">
                    <div class="q-title">Mobile No.</div>
                    <div class="q-field">
                        <textbox v-bind:textbox="tel"></textbox>
                    </div>     
                </div>

                <div class="terms-agree">
                    <div class="iblock marg-r-10"> 
                        <input-checkbox v-bind:inputButton="acceptTerms" v-bind:buttonSelected="termsSelected" v-on:changeButton="changeButtonTerms"></input-checkbox>
                    </div>
                    <span class="iblock" style="width: 80%;">By selecting "Get Cash Offer", I consent to receive text and email messages regarding my offer, appointment scheduling and the sale of my vehicle, from Money4Cars using an automated system at the mobile number I have provided. I agree to the Terms & Conditions.</span>
                </div>     

            </div>
            <div class="text-center pad-t-40">
                <button type="submit" class="m4c-btn color-white marg-r-10 marg-t-10"><span class="v-top">GET CASH OFFER</span></button>
            </div>
        </form>
    </div>
    </section>

    <wewFooterWhite></wewFooterWhite>

</div>
</template>

<script>
import wewHeader from '@/components/Header'
import wewSteps from '@/components/Steps'
import textbox from '@/components/input-text'
import inputButton from '@/components/input-button'
import inputCheckbox from '@/components/input-checkbox'
import wewFooterWhite from '@/components/wew-footer-white'


export default {
    name: 'step3',
    components: {
        wewHeader,
        wewSteps,
        textbox,
        inputButton,
        inputCheckbox,
        wewFooterWhite
    },
 data() {
        return {
            termsSelected: false,
            acceptTerms: {
                id: "acceptTerms",
                class: "accept-terms iblock",
                name: "accept",
                label: "",
                style: "",
                value: 0
            },
            firstName: {
                name: 'First Name',
                placeholder: '',
                class: 'm4c-textbox',
                veeRules: 'required|min:2|max:25',
                value: null
            },
            surname: {
                name: 'Surname',
                placeholder: '',
                class: 'm4c-textbox',
                veeRules: 'required|min:2|max:40',
                value: null
            },
            email: {
                name: 'Email',
                placeholder: '',
                class: 'm4c-textbox',
                veeRules: 'required|email|min:6',
                value: null
            },
            tel: {
                name: 'Phone',
                placeholder: '',
                class: 'm4c-textbox',
                veeRules: 'required|min:10|max:12',
                value: null
            }

        }
    },
computed: {
    submission() {
      return this.$store.getters.submission
    }
  },
methods: {
    changeButtonTerms(){
        this.termsSelected = !this.termsSelected;
    },
    validateBeforeSubmit(route) {
        this.$validator.validateAll().then((valid) => {
            if(valid){
                if(this.termsSelected) {
                        let payload = {
                        firstName: this.firstName.value,
                        surname: this.surname.value,
                        email: this.email.value,
                        tel: this.tel.value
                    }
                    this.$store.dispatch('storeCustomerDetails', payload)
                    this.$router.push(route)
                } 
            }
        })
    }
}
}
</script>

<style>
.step-4 h1{
    font-size: 38px;
    line-height: 38px;
    text-transform: uppercase;
    
}
.terms-agree{
    font-size: 15px;
    font-weight: 400;
    line-height:20px;
    color:#666;
    display: flex;
    flex-flow: row wrap;
    align-items: flex-start;
}
h2.car-title{
    text-transform: uppercase;
    font-size: 40px;
    line-height: 40px;
}

.reg-title{
    background:#CCCCCC;
    border-radius: 30px;
    padding: 2px 18px;
    display: inline-block;
    font-size: 18px;
    font-weight:800;
}
</style>
